import Image from 'next/image';
import styles from './loading-spinner.module.scss';

type Props = {
  spinnerId?: string;
};

export default function LoadingSpinner({ spinnerId = `loading-spinner` }: Props) {
  return (
    <div className={`${styles.loader} image-wrapper`} id={spinnerId}>
      <Image src="/next-assets/loaders/into.svg" alt="Content loading" width={50} height={50} />
    </div>
  );
}
